export default __webpack_public_path__ + "static/media/IconDesc_IronScrews.256.436f10ee.png";